import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);


    }
    init() {
        this.logo = this.$( 'logo' )[0];
        this.heading = this.$( 'heading' )[0];
        this.video = this.$( 'video' )[0];
        if( this.video ){
            this.videoSrc = this.$( 'source' )[0];
            this.video.src = this.videoSrc.dataset.src;
        }

        this.hasScrolled = false;
        if( ! this.video || ! this.heading || this.hasScrolled) {
            this.heading.classList.remove( 'opacity-0', 'translate-y-[1.0983606557em]' );
            return;
        }
        this.lenis = this.modules.Scroll.main.lenis;

        this.header = this.modules.PageHeader;
        this.lenis.on('scroll', args => {
            if( args.targetScroll > 10 ){
                if( ! this.hasScrolled ){
                    this.hasScrolled = true;
                    this.video.pause();
                    this.logo.classList.add( 'opacity-0' );
                    this.heading.classList.remove( 'opacity-0', 'translate-y-[1.0983606557em]' );
                   this.call( 'expandBackground', 'PageHeader' );
                }
            } else{
                if( this.hasScrolled ){
                    this.hasScrolled = false;
                    this.logo.classList.remove( 'opacity-0' );
                    this.heading.classList.add( 'opacity-0', 'translate-y-[1.0983606557em]' );
                    this.video.play();
                    this.call( 'collapseBackground', 'PageHeader' );
                }
            }
        });
    }
    destroy(){}
}
